export function isValidEmail(email) {
  // Regular expression for a valid email address
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the regex pattern
  return emailRegex.test(email);
}

export function transpose(matrix) {
  // Initialize the result array with empty subarrays
  let result = [];
  for (let i = 0; i < matrix[0].length; i++) {
    result.push([]);
  }

  // Fill the result array with transposed values
  for (let i = 0; i < matrix.length; i++) {
    for (let j = 0; j < matrix[0].length; j++) {
      result[j].push(matrix[i][j]);
    }
  }

  return result;
}

export function shuffleColumns(grid) {
  console.log({ grid });
  const res = grid.map((c) => shuffleArray(c));
  console.log({ res });
  return res;
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function flipArray(matrix) {
  // Check if the input is not empty
  if (!matrix || !matrix.length || !matrix[0].length) {
    return [];
  }

  // Get the number of rows and columns in the original matrix
  let m = matrix.length;
  let n = matrix[0].length;

  // Create a new matrix with dimensions n x m
  let flippedMatrix = Array.from({ length: n }, () => Array(m).fill(0));

  // Fill the new matrix with transposed values
  for (let i = 0; i < m; i++) {
    for (let j = 0; j < n; j++) {
      flippedMatrix[j][i] = matrix[i][j];
    }
  }

  return flippedMatrix;
}